import { useWizard } from "react-use-wizard";
import { TKeyOfDataWizardSell, TStringKeysOfIFillDataWizardSell } from "../..";
import { EReadinessForLowerSellPrice } from "../../../../../../shared/wizard/steps/types";
import sellSteps from "../sellSteps";
import OffersForClientStep from "../../../../../../shared/wizard/steps/offerForRieltorFromClientStep";

interface IKnowPriceStep_5 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardSell) => void;
  data: EReadinessForLowerSellPrice | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
}

const KnowPriceStep_5 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IKnowPriceStep_5) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.knowPrice.step_4);
    onReset(["offersForClient"]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.knowPrice.step_6);
  };

  return (
    <div>
      <OffersForClientStep
        onChange={onChange}
        onPrevStep={handlePrevStep}
        onNexStep={handleNexStep}
        data={data}
        isNextStepDisabled={isNextStepDisabled}
      />
    </div>
  );
};

export default KnowPriceStep_5;
